;(function($, undefined){
    'use strict';

    var rnn = window.rnn, log, maps, forms, Form, Field,
        imageUploadClass = 'imageUpload',
        imageUploadSelector = '.' + imageUploadClass,
        hasFileReader = !!window.FileReader,
        hasAjaxCapableSubmit = !!window.FormData;

    function clearError(){
        $(this.element).removeClass('error');
        return this;
    }

    function fieldError(form, next, error){
        if(error){
            $(this.element)
                .addClass('error')
                .find('button').focus();
        }
        next();
        return this;
    }


    function handleFileChange(imageUploadField, event){
        var target = $(event.target),
            imageUploader = target.closest(imageUploadSelector),
            preview = imageUploader.find('.preview');
            //TODO: if handling image clear button, completely nuke
            //and recreate input of type file for IE's sake here.

        getPreviewContent(target, function(result){
            preview.empty().append(result);
            imageUploadField.clearError();
        });
    }

    /* //This is the version from the old mobile picker
    function createImageUpload(options){
        var imageUploader = $(this),
            preview = $.el.div({'class':'preview'}),
            fileInputOptions = $.extend({type:'file'}, options),
            fileInput = $.el.input(fileInputOptions);

        imageUploader.append(preview, fileInput);

        // If the current browser is bad...
        !window.FileReader && imageUploader.addClass('legacy');
    }*/

    function createImageUpload(imageUploadField, options){
        options = options || {};

        var imageUploader = $($.el.div({'class':imageUploadClass})),
            preview = $.el.div({'class':'preview'}),
            instructions = $($.el.span()),
            fileInputOptions = $.extend({type:'file'}, options),
            buttonHolder = $.el.span({'class':'btnHolder'}),
            fakeButton = $.el.button({'class':'fake btn','type':'button'}, $.el.i({'class':'icon20x20-camera'}), ' Add Image'),
            fileInput = $.el.input(fileInputOptions);

        instructions.html(options.instructions);

        imageUploader.append(preview, instructions, $(buttonHolder).append(fakeButton, fileInput));

        $(fileInput).on('change', function(){
            handleFileChange(imageUploadField, event);
        });

        // If the current browser is bad...
        !window.FileReader && imageUploader.addClass('legacy');

        return imageUploader[0];
    }

    function getPreviewContent(fileInput, callback){
        var reader,
            previewImage;

        if(!window.FileReader){
            callback(fileInput.val());
            return;
        }

        reader = new window.FileReader();

        reader.onload = function(event){
            previewImage = $.el.img({'src':event.target.result});
            callback(previewImage);
        };

        reader.readAsDataURL(fileInput[0].files[0]);
    }

    function submitImageField(form, next){

        if (!hasFileReader) {
            form.submitWithIframe = true;
        }
        // We don't submit inside this widget anymore because we taught the forms class to do iframe submissions instead. We nicely ask forms to do it above.
        next();
    }

    function initImageUpload(){
        log = rnn.logging.log;
        maps = rnn.modules.maps;
        forms = rnn.modules.forms;
        Form = forms.Form;
        Field = forms.Field;

        function ImageUploader(){
            this.base.apply(this, arguments);
        }
        ImageUploader.prototype = Object.create(Field.prototype);
        ImageUploader.prototype.constructor = ImageUploader;
        ImageUploader.prototype.create = function(definition){
            var field = this;

            field.element = createImageUpload(this, definition);
            field.name = definition.name;

            return field;
        };
        ImageUploader.prototype.submit = submitImageField;
        ImageUploader.prototype.error = fieldError;
        ImageUploader.prototype.clearError = clearError;

        rnn.modules.imageUpload.ImageUploader = ImageUploader;
    }

    function addImageFieldsTo(form, imageUploadOptions, captionOptions){
        form.registerField(new rnn.modules.imageUpload.ImageUploader(imageUploadOptions));
        form.registerField($.extend(true, {}, captionOptions, {placeholder: 'Caption your image'}));

        form.fields[captionOptions.name].maxChars = 255;

        $(form.fields[imageUploadOptions.name].element).append(form.fields[captionOptions.name].element);

        return $.el.div({'class':imageUploadClass},form.fields[imageUploadOptions.name].element);
    }

    rnn.modules.register('imageUpload', {
        init: initImageUpload,
        addImageFieldsTo: addImageFieldsTo
    });

})(jQuery);
